import React, { useEffect } from "react";
import "../styles/delete-account-modal.css";

type DeleteAccountModalProps = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    loading?: boolean;
    lastAdministrator?: boolean;
};

export default function DeleteAccountModal({
    open,
    onClose,
    onConfirm,
    loading = false,
    lastAdministrator = false
}: DeleteAccountModalProps) {
    useEffect(() => {
        const onKey = (e: KeyboardEvent) => {
            if (open && e.key === "Escape" && !loading) {
                onClose();
            }
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [open, onClose, loading]);

    if (!open) return null;

    return (
        <div className="delete-account-modal-backdrop" onClick={loading ? undefined : onClose}>
            <div className="delete-account-modal" onClick={(e) => e.stopPropagation()}>
                <div className="delete-account-modal-header">
                    <h2>Are you sure you wish to delete?</h2>
                    <button
                        className="delete-account-modal-close"
                        onClick={onClose}
                        aria-label="Close"
                        disabled={loading}
                    >
                        ×
                    </button>
                </div>

                <div className="delete-account-modal-content">
                    <p className="delete-account-modal-message">
                        {lastAdministrator
                            ? "Are you sure you want to delete this organisation account? Everyone in the organisation will lose access immediately. Polaris will retain the organisation's data for up to 90 days to complete deletion, plus 30 days for reactivation, after which it will be permanently deleted and cannot be recovered. Deleting the account does not automatically issue a refund."
                            : "Are you sure you want to delete this account? Polaris will retain the data associated with this account for 30 days, after which it will be permanently deleted and cannot be recovered."}
                    </p>

                    <p className="delete-account-modal-contact">
                        {lastAdministrator
                            ? "If someone from this organisation would like to reactivate the account during this period, please contact"
                            : "If a new member of this organization would like to reactivate the account during this period, please contact"}
                        {' '}
                        <a href="mailto:support@polarisathlete.com" className="delete-account-modal-email">
                            support@polarisathlete.com
                        </a>.
                    </p>

                    <div className="delete-account-modal-actions">
                        <button
                            className="delete-account-cancel-btn"
                            onClick={onClose}
                            disabled={loading}
                        >
                            No, cancel
                        </button>
                        <button
                            className="delete-account-confirm-btn"
                            onClick={onConfirm}
                            disabled={loading}
                        >
                            {loading ? 'Deleting...' : 'Yes, delete'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

